






























import Vue from "vue";
import "@/components/icons";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Caption from "@/components/Atoms/Typography/Caption/index.vue";
import ButtonConfig from "@/components/Molecules/ButtonConfig/index.vue";
import Button from "@/components/Atoms/Button/index.vue";

import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "PlanListItem",
  components: {
    Heading,
    Caption,
    ButtonConfig,
    Button
  },
  props: {
    planId: {
      type: Number,
      required: true
    },
    graduateYear: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  methods: {
    handleClickPlan() {
      this.$router
        .push({
          name: "Plan",
          params: { planId: String(this.planId) }
        })
        .catch(err => err);
    },
    handleClickUpdateFloatingViewOpen() {
      this.$emit("clickUpdate", { planId: this.planId });
    },
    handleClickDuplication() {
      this.$emit("clickDuplication", { planId: this.planId });
    }
  }
});
